import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Store, Building2 } from "lucide-react";
import { useFilters } from "@/context/FilterContext";
import { useAuth } from "@/context/AuthContext";

export function BrandFilter() {
  const { isCorporate } = useAuth();
  const { nonCorpBrands, brandId, setBrandId, currentBrandName } = useFilters();

  if (!isCorporate) {
    return (
      <span
        data-testid="brand-context-indicator"
        className="inline-flex items-center gap-2 rounded-full border border-[var(--pb-border)] bg-[rgba(24,52,74,0.04)] px-3 py-1.5 text-sm font-medium text-[#18344A]"
      >
        <Store className="h-4 w-4 text-[#526E7E]" />
        {currentBrandName}
      </span>
    );
  }

  return (
    <Select value={brandId} onValueChange={setBrandId}>
      <SelectTrigger
        data-testid="brand-filter-select"
        className="h-10 w-[210px] rounded-full border-[var(--pb-border)] bg-white text-sm"
      >
        <div className="flex min-w-0 items-center gap-2">
          <Building2 className="h-4 w-4 flex-shrink-0 text-[#526E7E]" />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Brands</SelectItem>
        {nonCorpBrands.map((b) => (
          <SelectItem key={b.id} value={b.id} data-testid={`brand-option-${b.id}`}>
            {b.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
